import { authedApiFetch } from './Api';

export const getCurrentUser = async () => {
	// fetch and refresh stored user
	const storedUser = JSON.parse(localStorage.getItem('user'));

	if (!storedUser?.id) {
		return null;
	}

	const user = await authedApiFetch({
		endpoint: `/users/${storedUser.id}`,
		method: 'GET',
	});

	localStorage.setItem('user', JSON.stringify(user));

	return user;
};
